
import React from "react";
import "./Partnerships.scss";
import Page from "app/utils/Page/Page";
import Header from "app/components/molecules/Header/Header";
import RenderHTML from "app/components/atoms/RenderHtml";


const NetworkList = (props) => {
  const { data, img, title } = props;
  const list =
    data.map((item, i) => {
      if (item) {
        return (
          <li key={i}>{item}</li>
        )
      }
    })
  return (
    <div className="skill-list">
      <ul>
        {list}
      </ul>
    </div>

  )
}


const Partnerships = () => {

  const data = window.siteData.partnerships;

  const aboutValues = window.siteData.aboutusValues;


  let networkList = [];
  let partnerLogos = [];
  let partnerLogosLinks = [];

  aboutValues.forEach(element => {
    networkList.push(element['Network list'])
    partnerLogos.push(element['Partner logos'])
    partnerLogosLinks.push(element['Partner logos link'])
  });


  return (
    <Page
      id="s-config-tool"// {`${TargetConfig.id}-config-tool`}
      title="Turris home health solutions"
      description="Turris home health solutions" // {TargetConfig.description}
    >
      <div className="section-container bg-cover">

        <Header page="partnerships" />

        <section className="sub-section partnerships">

          {
            data.map((item, i) => {

              if (item.type === 'H1') {
                return (
                  <span key={i}>
                    {
                      i != 0 &&
                      <img src="images/icons/red-heart-icon.svg" className="heart" />
                    }
                    <h2 style={{ color: i == 0 ? '#ED1E45' : '#0a1633' }}>{item.value}</h2>
                  </span>
                )
              } else
                if (item.type === 'H2') {
                  return (
                    <span key={i}>
                      {
                        i != 0 &&
                        <img src="images/icons/red-heart-icon.svg" className="heart" />
                      }
                      <h3>{item.value}</h3>
                    </span>
                  )
                } else {
                  return (
                    <p key={i} ><RenderHTML HTML={item.value} /></p>

                  )
                }

            })
          }

          <div className="skill-list-box">
            <NetworkList data={networkList} />
          </div>

          <div className="logos">
            {
              partnerLogos.map((item, i) => {

                if (item) {
                  return (
                    <div key={i} className="logos-div">
                      <a href={partnerLogosLinks[i]} target="_blank">
                        <img src={`images/${item}`} />
                      </a>
                    </div>
                  )
                }
              })
            }

          </div>

        </section>

      </div>

    </Page>
  )
}

export default Partnerships;
